/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-24 14:00:21
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-01 22:56:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/TimePickerModal/index.tsx
 */
import { RangePicker } from '@/src/components';
import { Button, Modal } from '@/src/components/Antd';
import moment, { Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';

export interface DateRange {
  beginDate: string;
  beginTime: string;
  endDate: string;
  endTime: string;
}

type Props = {
  hideTitle?: boolean;
  visible: boolean;
  onCancel: () => void;
  afterClose: () => void;
  onSubmit: (start: Moment, end: Moment) => void;
  occupiedRanges: Array<{
    beginDate: string;
    beginTime: string;
    endDate: string;
    endTime: string;
  }>;
  timezoneGmt: string;
  date: {
    startTime: string;
    endTime: string;
  };
};

function TimePickerModal({
  visible,
  onCancel,
  onSubmit,
  afterClose,
  occupiedRanges,
  timezoneGmt,
  hideTitle,
  date,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [startTime, setStartTime] = useState(date.startTime);
  const [endTime, setEndTime] = useState(date.endTime);
  const handleChangeTime = (value: DateRange) => {
    const { beginDate, beginTime, endDate, endTime } = value;
    setStartTime(beginDate && beginTime ? `${beginDate} ${beginTime}` : null);
    setEndTime(endDate && endTime ? `${endDate} ${endTime}` : null);
  };

  const inner_trasnformTime = (t: string) => {
    const m = moment(t);
    const date = t ? m.format('YYYY-MM-DD') : null;
    const time = t ? m.format('HH:mm') : null;
    return { date, time };
  };

  const startTimeString = inner_trasnformTime(startTime);
  const endTimeString = inner_trasnformTime(endTime);
  useEffect(() => {
    setStartTime(date.startTime);
    setEndTime(date.endTime);
  }, [date]);

  return (
    <Modal
      width={600}
      title={getI18n('general.editCampaignTime')}
      visible={visible}
      onCancel={onCancel}
      afterClose={afterClose}>
      <div className={styles.container}>
        {!hideTitle && (
          <div className={styles.title}>
            {getI18n('general.editCampaignTimeTip')}
          </div>
        )}
        <div className={styles.timePicker}>
          <RangePicker
            id={`time-picker-${Math.random()}`}
            value={{
              beginDate: startTimeString.date,
              beginTime: startTimeString.time,
              endDate: endTimeString.date,
              endTime: endTimeString.time,
            }}
            occupiedRanges={occupiedRanges}
            onChange={handleChangeTime}
          />
        </div>
        <div className={styles.footer}>
          <Button onClick={onCancel} className={styles.btn}>
            {getI18n('general.discard')}
          </Button>
          <Button
            type={'primary'}
            onClick={onSubmit ? onSubmit.bind(this, startTime, endTime) : null}
            className={styles.btn}>
            {getI18n('general.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default TimePickerModal;
